// extracted by mini-css-extract-plugin
export default {"guide":"_2yCVGLReBhky4U_cIc2W6z position-absolute pointerEvents-none borderStyle-dotted"};